import { triggerToast } from "@/wc/components/base/nw-toast";
import { getFromLocalStorage, hasLocalStorage, removeFromLocalStorage, saveToLocalStorage } from "@/utils/localStorage";

import { ErrorService } from "../errorService";

/**
 * Service to handle feature refresh notifications and timing
 */
export class RefreshService {
  private readonly FEATURE_REFRESH_STORAGE_KEY = "nft-ls-d";

  /**
   * Starts monitoring for feature refresh notifications
   */
  public startMonitoring() {
    this.assessTimedFeatureRefresh();
  }

  // public assessProjectReset(_project: Project): void {
  //   if (project.id != null && project.hasUpdates) {
  //     openModal("projectUpdate", { projectId: project.id });
  //   }
  // }

  /**
   * Checks if it's time to show the feature refresh notification and handles the timing logic
   */
  public assessTimedFeatureRefresh(): void {
    try {
      if (!hasLocalStorage()) {
        return;
      }

      const nftDate = getFromLocalStorage<string>(this.FEATURE_REFRESH_STORAGE_KEY);

      if (!nftDate || !this.isDateValid(nftDate)) {
        this.saveFutureTriggerDate();
        return;
      }

      const today = new Date();
      const triggerDate = new Date(nftDate);

      if (today >= triggerDate) {
        removeFromLocalStorage(this.FEATURE_REFRESH_STORAGE_KEY);

        triggerToast({
          title: "🎉 Exciting news, a new feature is ready!",
          message: "Refresh your page to roll out the new feature and enhance your learning experience.",
          dismissType: "manual",
          position: "top",
          withGraphic: true,
          action: {
            label: "Refresh page",
            onClick: () => {
              window.location.reload();
            },
          },
        });

        this.saveFutureTriggerDate();
      }
    } catch (error) {
      ErrorService.report(error instanceof Error ? error : new Error("Error while triggering new feature toast"));
    }
  }

  private saveFutureTriggerDate(): void {
    const triggerDate = this.getFutureTriggerDate();
    saveToLocalStorage(this.FEATURE_REFRESH_STORAGE_KEY, triggerDate.toISOString());
  }

  private getFutureTriggerDate(): Date {
    const randomDays = Math.floor(Math.random() * 6) + 2;
    const date = new Date(Date.now() + randomDays * 24 * 60 * 60 * 1000);
    console.log("triggerDate", date);
    return date;
  }

  private isDateValid(date: string): boolean {
    return !isNaN(new Date(date).getTime());
  }
}
